module.exports = __webpack_public_path__ + "img/92.ef1f751a.jpg";